import { render, staticRenderFns } from "./UnderConstruction.vue?vue&type=template&id=009a7b60&scoped=true"
var script = {}
import style0 from "./UnderConstruction.vue?vue&type=style&index=0&id=009a7b60&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "009a7b60",
  null
  
)

export default component.exports